<template>
  <v-card outlined class="mb-4">
    <form @keydown.enter.prevent="submit()">
      <v-card-text class="mt-5">

        <v-row v-if="isService" class="mb-0 pb-0">
          <v-col cols="12" md="4" lg="4">
            <el-text-field
              label="Paslaugos kodas"
              disabled
              v-model="formData.product_type_id"
              :maxlength="20"
            />
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <el-text-field
              label="RC SES kodas"
              disabled
              v-model="formData.rc_ses_code"
              :maxlength="20"
            />
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <el-text-field
              label="Paslauga"
              disabled
              v-model="formData.product_type_title"
              :maxlength="20"
            />
          </v-col>
        </v-row>
        <v-row v-else class="mb-0 pb-0">
          <v-col cols="12" md="4" lg="4">
            <el-text-field
              label="Sąrašo kodas"
              disabled
              v-model="formData.list_type_id"
              :maxlength="20"
            />
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <el-text-field
              label="RC SES kodas"
              disabled
              v-model="formData.rc_ses_code"
              :maxlength="20"
            />
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <el-text-field
              label="Sąrašas"
              disabled
              v-model="formData.product_type_title"
              :maxlength="20"
            />
          </v-col>
        </v-row>

        <v-tabs>
          <v-tab>{{ $t('Leidimai') }}</v-tab>
          <v-tab>{{ $t('Draudimai FA') }}</v-tab>
          <v-tab>{{ $t('Draudimai JA') }}</v-tab>
          <v-tab-item>

            <el-select-table
              title="Tikrinimas vykdomas Asmenų posistemėje (AMNT_TIPAS)"
              elKey="amnt_type_list"
              :available-items="amntTypes"
              :selected-items="formData.amnt_type_list"
              availableTitle="Galimos reikšmės"
              selectedTitle="Pasirinkti leidimai"
              item-key="value"
              item-name="text"
              @move-to-selected="moveToSelected"
              @move-to-available="moveToAvailable"
            />

            <el-select-table
              title="JA atstovo vaidmuo gaunamas iš RC SES aplikacijos (FAVA_ID)"
              elKey="fava_id_list"
              :available-items="jarRoles"
              :selected-items="formData.fava_id_list"
              availableTitle="Galimos reikšmės"
              selectedTitle="Pasirinkti leidimai"
              item-key="value"
              item-name="text"
              @move-to-selected="moveToSelected"
              @move-to-available="moveToAvailable"
            />

            <el-select-table
              title="Įgaliotinio vaidmuo (FATE_ID)"
              elKey="fate_ids"
              :available-items="fateIds"
              :selected-items="formData.fate_ids"
              availableTitle="Galimos reikšmės"
              selectedTitle="Pasirinkti leidimai"
              item-key="value"
              item-name="text"
              @move-to-selected="moveToSelected"
              @move-to-available="moveToAvailable"
            />
          </v-tab-item>

          <v-tab-item>
            <v-container fluid>
              <v-row>
                <v-col class="pt-0" cols="12" md="12">
                  <h3>Mirties faktas</h3>
                  <el-checkbox
                    class="my-0"
                    style="width: fit-content;"
                    label="Tikrinti asmens mirties faktą ASMENYS"
                    v-model="formData.is_dead_checked"
                  >
                  </el-checkbox>
                </v-col>

                <v-col class="pt-0" cols="12" md="12">
                  <h3>Asmens neveiksnumas</h3>
                  <el-checkbox
                    class="my-0"
                    style="width: fit-content;"
                    label="Tikrinti asmens neveiksnumą NIRVAR"
                    v-model="formData.is_nirvar_checked"
                  >
                  </el-checkbox>
                </v-col>
              </v-row>
            </v-container>

            <el-select-table
              title="NIRVAR sritys. Pasirenkamos sritys, kurioms leidžiama gauti paslaugą."
              elKey="nirvars"
              :available-items="nirvars"
              :selected-items="formData.nirvars"
              availableTitle="Galimos reikšmės"
              selectedTitle="Pasirinktos išimtys"
              item-key="value"
              item-name="text"
              @move-to-selected="moveToSelected"
              @move-to-available="moveToAvailable"
            />
          </v-tab-item>

          <v-tab-item>
            <v-container fluid>
              <v-row>
                <v-col class="pt-0" cols="12" md="12">
                  <h3>Teisių riba</h3>
                  <el-checkbox
                    class="my-0"
                    style="width: fit-content;"
                    label="Tikrinti teisių ribų žymą"
                    v-model="formData.is_restriction_checked"
                  >
                  </el-checkbox>
                </v-col>
              </v-row>
            </v-container>

            <el-select-table
              title="JA teisinis statusas"
              elKey="ja_legal_list"
              :available-items="jaLegalStatus"
              :selected-items="formData.ja_legal_list"
              availableTitle="Galimos reikšmės"
              selectedTitle="Pasirinkti draudimai"
              item-key="value"
              item-name="text"
              @move-to-selected="moveToSelected"
              @move-to-available="moveToAvailable"
            />

            <el-select-table
              title="JAR teisinė forma"
              elKey="ja_forms"
              :available-items="jarForms"
              :selected-items="formData.ja_forms"
              availableTitle="Galimos reikšmės"
              selectedTitle="Pasirinkti draudimai"
              item-key="value"
              item-name="text"
              @move-to-selected="moveToSelected"
              @move-to-available="moveToAvailable"
            />
          </v-tab-item>
        </v-tabs>

      </v-card-text>

      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            class="mr-1"
            color="secondary"
            icon="atšaukti"
            title="Atšaukti"
            @click.native.stop="back()"
            :loading="loading"
          />
          <el-button
            title="Išsaugoti"
            :loading="loading"
            @click.native="save()"
            color="primary"
            icon="išsaugoti"
          />
        </v-row>
      </v-card-actions>
    </form>
  </v-card>
</template>

<script>
import ElSelectTable from '@/components/elements/ElSelectTable'
import LimitationTypes from '@/components/constants/rcSesLimitationTypes.js'

export default {
  name: 'LimitationCardBody',
  components: {
    ElSelectTable
  },
  props: {
    type: [String],
    formData: [Object, Array],
    jarRoles: [Object, Array],
    amntTypes: [Object, Array],
    jaLegalStatus: [Object, Array],
    fateIds: [Object, Array],
    nirvars: [Object, Array],
    jarForms: [Object, Array],
    loading: [Boolean]
  },
  computed: {
    isService() {
      return LimitationTypes.Service == this.type
    }
  },
  data() {
    return {
      completedTasks: [
        { taskId: '4', taskName: 'Clean the House' },
      ],
    };
  },
  methods: {
    save() {
      this.$emit('save')
    },
    back() {
      this.$emit('back')
    },
    moveToSelected(item, key) {
      this.$emit('move-to-selected', item, key);
    },
    moveToAvailable(item, key) {
      this.$emit('move-to-available', item, key);
    },
  }
}
</script>

<style>

</style>
